<template lang="html">
<div style="height: 100%;">
  <div class="button-wrap toolbar" style="position:absolute; padding:20px; z-index:9999;">
      <button type="button" class="btn btn-default btn-" @click="exportCounter">
        <span class="btn-icon">
          <i class="iconfont icon-export"></i>
        </span>
        导出用户用水信息
      </button>
  </div>
  <!-- <DataTablePage ref="historyTable" mainColumn="" longColumn="" title="用户用水统计" label="用水" labelName="" :resource="resource" :noOperationList="noOperationList" :updateList="updateList" :tableFullList="tableFullList" :filterInitList="filterInitList" :columns="columns"></DataTablePage> -->
  <DataTablePage ref="historyTable" mainColumn="" longColumn="" title="用水历史" label="用水" labelName="" :resource="resource" :noOperationList="noOperationList" :tableFullList="tableFullList" :tableInitList="tableInitList" :filterInitList="filterInitList" :columns="columns" :createFormValues="createFormValues" @changeFormValue="changeFormValue"></DataTablePage>
</div>
  <!-- DataTablePage(
    ref="uws"
    mainColumn=""
    longColumn=""
    title="用户用水统计"
    label="用水"
    labelName=""
    :resource="resource"
    :noOperationList="true"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :columns="columns"
    :createFormValues="createFormValues"
    @changeFormValue="changeFormValue")-->
</template>
<script>
import axios from 'axios'
import { fetch } from '@/utils/api'
import DataTablePage from '@/containers/DataTablePage'
import columns from './waterColumns.js'
import { expire } from '@/utils/auth'
export default {
  name: 'uws',
  components: {
    DataTablePage
  },
  data () {
    let startData = new Date()
    let startStamp = new Date(startData.setDate(startData.getDate() - 31)).getTime()
    let endData = new Date()
    let endStamp = new Date(endData.setDate(endData.getDate() - 1)).getTime()
    return {
      noOperationList: true,
      copyTableData: [], // table列表数据
      resource: '/nb/wus/base',
      tableFullList: ['hno', 'hname', 'counterCode', 'lnum', 'limage', 'tnum', 'timage', 'quanty'],
      tableInitList: ['hno', 'hname', 'counterCode', 'lnum', 'limage', 'tnum', 'timage', 'quanty'],
      filterFullList: ['areaId', 'time'],
      filterInitList: ['areaId', 'time'],
      createFormValues: {
        time: [startStamp, endStamp]
      },
      columns: {
        ...columns,
        hno: {
          label: '户号',
          type: 'input',
          width: 110,
          form: {
            type: 'input',
            size: 10,
            columnSize: [{
              type: 'md',
              size: 6
            }, {
              type: 'sm',
              size: 12
            }]
          },
          filter: {
            type: 'input',
            width: 100,
            like: true
          }
        },
        limage: {
          label: '抄表行码',
          width: 220,
          type: 'custom',
          html: true,
          magnifying: {
            height: '180px',
            width: '200px'
          },
          style: {
            textAlign: 'center'
          },
          customRender (data, full, index) {
            return `<img src="${data}" style="height:24px"></img>`
          }
        },
        timage: {
          label: '抄表行码',
          width: 220,
          type: 'custom',
          html: true,
          magnifying: {
            height: '180px',
            width: '200px'
          },
          style: {
            textAlign: 'center'
          },
          customRender (data, full, index) {
            return `<img src="${data}" style="height:24px"></img>`
          }
        },
        quanty: {
          label: '用水量',
          width: 100,
          style: {
            textAlign: 'center'
          }
        },
        // 时间
        time: {
          label: '抄表时间',
          type: 'time',
          width: 180,
          // size: 8,
          dataType: 'YYYY-MM-DD',
          filter: {
            type: 'daterange',
            rules: [{ type: 'required', message: '请选择时间' }]
          },
          form: {
            type: 'date'
          }
        }
      }
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    this.renderRecord('processing')
  },
  methods: {
    renderTableData (data) {
      this.copyTableData = data.data
    },
    exportCounter () {
      console.log('开始导出计量设备')
      // 导出计量设备
      fetch({
        url: '/nb/wus/export',
        params: {
          exportDataType: 'ExportDataTypeUserStatistics'
        }
      }).then(data => {
        console.log(data)
        if (data) {
          if (data.id === 0) {
            this.intervalId = setInterval(this.checkExportProcess, 1000)
          } else {
            this.$swal(data.message, '', 'warn')
          }
        } else {
          this.$swal('导出失败!', '', 'error')
        }
      })
      console.log('结束导出计量设备')
    },
    checkExportProcess () {
      fetch({
        url: '/nb/wus/exportCheck',
        params: {
          exportDataType: 'ExportDataTypeUserStatistics'
        }
      }).then(data => {
        console.log(data)
        if (data) {
          console.log(data.message + ',' + data.id)
          if (data.id !== 6) {
            const status = data.id === 0 ? 'success' : 'warn'
            this.$swal(data.message, '', status)
            clearInterval(this.intervalId)
            if (status === 'success') {
              axios({
                method: 'POST',
                url: '/nb/wus/download?exportDataType=ExportDataTypeUserStatistics',
                data: {},
                responseType: 'arraybuffer'
              }).then(response => {
                console.log(response)
                if (!response) {
                  return
                }
                let contentDispostion = response.headers['content-disposition'].split(';')[1]
                let fileName = decodeURIComponent(contentDispostion.split('=')[1])
                console.log(contentDispostion)
                let url = window.URL.createObjectURL(new Blob([response.data]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', fileName)
                document.body.appendChild(link)
                link.click()
              }).catch(error => {
                console.log(error)
              })
            }
          }
        } else {
          clearInterval(this.intervalId)
          this.$swal('导出失败!', '', 'error')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// userWaterStatistics.vue?55df409f